<script>export default { name: "LocalDataOnlyInfoPanel"}</script>

<template>
    <div style="color:red; font-style: italic; font-size:0.9rem;">
        {{ $t("info-panels.local-data-only") }}
    </div>
</template>